import { Outlet, useRouteLoaderData } from "react-router-dom";
import CommonHeader from "../components/CommonHeader";
import CommonFooter from "../components/CommonFooter";
import { User } from "../services/user/userModel";
import { useScrollTopOnNavigation } from "../components/shell/useScrollTopOnNavigation";

const PrivateArea = () => {
  const { loggedUser } = useRouteLoaderData("logged-user") as {
    loggedUser?: User;
  };
  const mainRef = useScrollTopOnNavigation();

  return (
    <div className="shell --candidate">
      <div className="shell_main" ref={mainRef}>
        <CommonHeader loggedUser={loggedUser} />
        <main className="shell_content">
          <Outlet />
        </main>
        <CommonFooter loggedUser={loggedUser} />
      </div>
    </div>
  );
};

export default PrivateArea;
